import {
    Box,
    Button,
    Divider,
    List,
    ListDivider,
    ListItem,
    ListItemButton,
    ListSubheader,
    Stack, Tooltip,
    Typography
} from "@mui/joy";
import {ICON_SIZE, sidebarMenus} from "../../values/sidebarMenus";
import React from "react";
import FullLogo from "../FullLogo";
import {useLocation, Link} from "react-router-dom";
import {SxProps} from "@mui/joy/styles/types";
import {BellIcon, CogIcon, Library, LogOutIcon} from "lucide-react";
import {useUITheme} from "../../hooks/useUITheme";
import {useAuth} from "../../hooks/useAuth";
import Logo from "../Logo";
import {useTranslation} from "react-i18next";

const BottomNavbar = () => {
    const uiTheme = useUITheme()
    return <Box height={"max-content"} width={"100%"} paddingX={{sm: 3, xs:1}} paddingY={1} gap={2}
                alignItems={"center"}
                boxSizing={"border-box"} display={{xs: "flex", md: "none"}}
        // display={{md: "flex", xs: "none"}}
                sx={{
                    backdropFilter: uiTheme.sideBarProps.backdropFilter,
                    border: uiTheme.sideBarProps.border,
                    backgroundColor: uiTheme.sideBarProps.backgroundColor,
                }}>

        <BottomNavbarContent/>

    </Box>
}

export const BottomNavbarContent = () => {
    const location = useLocation()
    const uiTheme = useUITheme()
    const {t} = useTranslation()

    return <Stack alignItems={"center"} justifyContent={"space-between"} width={"100%"} boxSizing={"border-box"}
                  gap={3}>

        <List sx={{gap: 1, flexDirection: "row", justifyContent: "space-between", width: "100%"}}>
            {sidebarMenus.map((menu, index, array) =>
                <ListItem nested>
                    <Link to={menu.route}
                          style={{textDecoration: "none", display: "flex", justifyContent: "center"}}>
                        <ListItem data-selected={location.pathname === menu.route}
                                  sx={{
                                      borderRadius: 15,
                                      paddingX: 1,
                                      paddingY: .5,
                                      justifyContent: "center",
                                      color: location.pathname === menu.route ? uiTheme.sideBarProps.selectedTextColor : uiTheme.sideBarProps.textColor,
                                  }}>
                            <Stack alignItems={"center"} gap={0.5}>
                                {menu.icon}
                                <Typography textAlign={"center"} level={"body-sm"} sx={{color: "inherit"}}>
                                    {t(menu.label)}
                                </Typography>
                            </Stack>

                        </ListItem>
                    </Link>
                </ListItem>)}

        </List>


    </Stack>

}


export default BottomNavbar